export const FETCH_QUIZ_RESULT_REQUEST = "FETCH_QUIZ_RESULT_REQUEST";
export const FETCH_QUIZ_RESULT_SUCCESS = "FETCH_QUIZ_RESULT_SUCCESS";
export const FETCH_QUIZ_RESULT_FAILURE = "FETCH_QUIZ_RESULT_FAILURE";

export const ADD_QUIZ_RESULT_REQUEST = "ADD_QUIZ_RESULT_REQUEST";
export const ADD_QUIZ_RESULT_SUCCESS = "ADD_QUIZ_RESULT_SUCCESS";
export const ADD_QUIZ_RESULT_FAILURE = "ADD_QUIZ_RESULT_FAILURE";
